import { Box } from "@chakra-ui/react";
import { FC } from "react";
import { NavLink } from "react-router";

import { RanaLogoIcon, hasRanaTenant, retrieveTenantAndOrganisation } from "@nens/ranalib";

import { useBreadcrumbs } from "../hooks/breadcrumbs";

// We want to style UUIDs slightly different compared other titles
const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const Breadcrumbs: FC = () => {
  const crumbs = useBreadcrumbs("Rana HCC");
  const getTextColor = (index: number, totalCrumbs: number): string => {
    return totalCrumbs > 1 && index === totalCrumbs - 1 ? "brand.grey.600" : "brand.deep_sea";
  };

  const ranaLink = hasRanaTenant() ? `/${retrieveTenantAndOrganisation().tenant}/` : "/login";
  return (
    <Box
      height="65px"
      display="inline-flex"
      flexWrap="wrap"
      alignItems="center"
      fontSize="1.2em"
      overflowX="hidden"
      borderWidth="base"
      borderStyle="solid"
      borderColor="brand.glacier"
      borderRadius="4px"
      padding="12px 16px"
      margin="16px 0"
    >
      <div>
        <NavLink to={ranaLink} title="To Rana dashboard" reloadDocument>
          <Box as="span" color="brand.deep_sea">
            <RanaLogoIcon color="brand.clear_creek" marginRight="4px" />
            Rana
          </Box>
        </NavLink>
        <span style={{ marginLeft: 20, marginRight: 20 }}>&#062;</span>{" "}
      </div>

      {crumbs.map(({ title, url }, idx) => (
        <div key={url}>
          <NavLink
            to={url}
            key={url}
            title={title}
            style={UUID_REGEX.test(title) ? { minWidth: 0, overflow: "hidden" } : undefined}
          >
            {" "}
            <Box
              as="span"
              color={getTextColor(idx, crumbs.length)}
              textTransform={UUID_REGEX.test(title) ? "lowercase" : "capitalize"}
              whiteSpace={UUID_REGEX.test(title) ? "nowrap" : undefined}
              textOverflow={UUID_REGEX.test(title) ? "ellipsis" : undefined}
              overflow={UUID_REGEX.test(title) ? "hidden" : undefined}
            >
              {title}
            </Box>
          </NavLink>
          {idx === crumbs.length - 1 ? null : (
            <span style={{ marginLeft: 20, marginRight: 20 }}>&#062;</span>
          )}
        </div>
      ))}
    </Box>
  );
};

export default Breadcrumbs;
